const dutyorder = {
  getlist: 'dutyorder/getlist',
  get: 'dutyorder/get',
  changestatus: 'dutyorder/change-status',
}
export default dutyorder
